'use strict';

const pcpColorFilter = (function() {
  const colorPortfolio = document.querySelector('.color-portfolio');
  const portfolioDriver = document.querySelector('.portfolio-driver');
  const applicationInteriorRadio = document.getElementById('interior');
  const applicationExteriorRadio = document.getElementById('exterior');
  const filterFilters = document.querySelector('.js-filter-filters');
  const wheel = document.getElementById('color-wheel');
  const wheelSlices = Array.from(document.querySelectorAll('.color-slice'));
  const wheelDots = Array.from(document.querySelectorAll('.color-slice__dot'));
  const wheelText = document.querySelector('.wheel-text');
  const applyFilterButton = document.querySelector('.js-apply-filter');
  const swatchLists = document.querySelectorAll('.swatch-list');
  const swatchListWrappers = document.querySelectorAll('.swatch-list__wrapper');
  const disabledClass = 'is-disabled';
  const selectedClass = 'is-selected';
  const visibleClass = 'is-visible';
  const expandedClass = 'is-expanded';
  const hiddenClass = 'is-hidden';
  const colors = [
    'reds',
    'neutral',
    'purples',
    'blues',
    'greens',
    'yellows',
    'oranges',
  ];
  let isMobile = false;
  let isTablet = false;
  let canShow = false;
  let html = '';
  function breakpointHandler() {
    const viewportWidth =
      window.innerWidth || document.documentElement.clientWidth;
    isMobile = viewportWidth > 767 ? false : true;
    isTablet = viewportWidth > 1025 ? false : true;
    return {
      isMobile,
      isTablet,
    };
  }
  function colorHomepageCheck() {
    if (window.location.href.split('/colors')[1].length <= 1) {
      canShow = true;
    } else {
      canShow = false;
    }
  }
  function heroGradientHandler() {
    const hero = document.querySelector('.full-screen-hero');
    for (let color of colors) {
      if (window.location.href.indexOf(color) > -1) {
        hero.classList = 'full-screen-hero';
        hero.classList.add(`is-gradient-${color}`);
      }
    }
  }
  function getFilterFilters() {
    const interiorCount =
      !isMobile && !isTablet
        ? document.querySelectorAll('.swatch-list--desktop .is-not-exterior')
            .length
        : document.querySelectorAll('.swatch-list--mobile .is-not-exterior')
            .length;
    const exteriorCount =
      !isMobile && !isTablet
        ? document.querySelectorAll('.swatch-list--desktop .is-exterior').length
        : document.querySelectorAll('.swatch-list--mobile .is-exterior').length;
    let hasColor = false;
    let filterText = '';
    for (let color of colors) {
      const colorCount =
        !isMobile && !isTablet
          ? document.querySelectorAll(
              `.swatch-list--desktop .color-type-${color}`
            ).length
          : document.querySelectorAll(
              `.swatch-list--mobile .color-type-${color}`
            ).length;
      if (window.location.href.indexOf(color) < -1) {
        hasColor = false;
      } else if (window.location.href.indexOf(color) > -1) {
        hasColor = true;
      }
      if (window.location.href.indexOf(color) > -1 && hasColor) {
        filterText += ` / ${color} / ${colorCount} Available`;
      }
    }
    if (window.location.href.indexOf('interior') > -1 && !hasColor) {
      filterText += ` / Interior / ${interiorCount} Colors Available`;
    }
    if (window.location.href.indexOf('exterior') > -1 && !hasColor) {
      filterText += ` / Exterior / ${exteriorCount} Colors Available`;
    }
    return filterText;
  }
  function filterLabelHandler() {
    filterFilters.innerHTML = getFilterFilters();
  }
  function removeLoader() {
    swatchListWrappers.forEach(wrapper => {
      if (wrapper.classList.contains(hiddenClass)) {
        wrapper.classList.remove(hiddenClass);
        colorPortfolio.querySelector('.loading').classList.add(hiddenClass);
      }
    });
  }
  /**
   *
   * @param swatchList - mobile swatch list
   */
  function adjustMobileRows(swatchList) {
    const modifiedSwatchRows = Array.from(
      swatchList.querySelectorAll('.js-swatch-row.is-mobile')
    );
    html = '';
    // 3rd rewrap of rows
    for (let i = 0; i < modifiedSwatchRows.length; i += 5) {
      html += `<div class="swatch-list js-expand-all-content js-mobile-row">
        ${modifiedSwatchRows
          .slice(i, i + 4)
          .map(row => {
            return `${row.outerHTML}`;
          })
          .join('')}
      </div>
      ${modifiedSwatchRows[i + 4].outerHTML}`;
    }
    swatchList.innerHTML = html;
    const mobileSwatchRows = Array.from(
      document.querySelectorAll('.js-mobile-row')
    );
    // append swatch group expand buttons
    // to leading visible rows
    if (canShow) {
      mobileSwatchRows.forEach(row => {
        const firstChild = row.children[0];
        firstChild.innerHTML += `
          <button class="swatch-list__expand-button md:hidden js-expand-all-trigger">
            <svg class="icon icon-plus bg-white rounded-full"><use xlink:href="#icon-plus"></use></svg>
          </button>
        `;
        const wrapper = document.createElement('div');
        wrapper.classList = 'swatch-list js-expand-all';
        row.parentNode.insertBefore(wrapper, row);
        wrapper.appendChild(row);
      });
    }
  }
  /**
   *
   * @param swatchList - swatch list
   * @param isDesktop - boolean for desktop vs. mobile
   */
  function adjustSwatchRows(swatchList, isDesktop) {
    const swatchSize = isDesktop ? 10 : 5;
    const lastRowClass = 'js-last-row';
    let customRows;
    let lastRow;
    const swatches = Array.from(
      swatchList.querySelectorAll('.swatch-list__list-item')
    );
    // rewrap swatches into groups of 10 for desktop
    for (let i = 0; i < swatches.length; i += swatchSize) {
      html += `<div class="swatch-list js-swatch-row ${
        isDesktop ? 'is-desktop' : 'is-mobile'
      }">
        ${swatches
          .slice(i, i + swatchSize)
          .map(swatch => {
            return `${swatch.outerHTML}`;
          })
          .join('')}
      </div>`;
    }
    swatchList.innerHTML = html;
    customRows = document.querySelectorAll('.js-swatch-row');
    removeLoader();
    // update the last row in the list to maintain card widths
    // if less than 10 swatches exist
    if (customRows) {
      lastRow = customRows[customRows.length - 1];
      lastRow.classList.add(lastRowClass);
    }
    if (!isDesktop && canShow) {
      adjustMobileRows(swatchList);
      removeLoader();
    }
  }
  function pageUpdatesHandler() {
    swatchLists.forEach(list => {
      const swatches = Array.from(
        list.querySelectorAll('.swatch-list__list-item')
      );
      const isDesktop =
        list.classList.contains('swatch-list--desktop') &&
        window.getComputedStyle(document.querySelector('.swatch-list--desktop'))
          .display !== 'none';
      const isMobile =
        list.classList.contains('swatch-list--mobile') &&
        window.getComputedStyle(document.querySelector('.swatch-list--mobile'))
          .display !== 'none';
      // disable swatches if viewing application URL
      [...swatches].forEach(swatch => {
        for (let color of colors) {
          if (
            window.location.href.indexOf(`interior/${color}`) > -1 ||
            window.location.href.indexOf(`exterior/${color}`) > -1
          ) {
            if (!swatch.classList.contains(`color-type-${color}`)) {
              swatch.classList.add(disabledClass);
            }
          }
        }
      });
      // adjust swatch rows
      if (isDesktop) adjustSwatchRows(list, true);
      if (isMobile) adjustSwatchRows(list, false);
    });
    // update color filters to match URL if not on colors homepage
    for (let color of colors) {
      if (window.location.href.indexOf(color) > -1) {
        if (color === 'neutral') color = 'grey';
        wheelSlices.forEach(slice => {
          if (color.replace('s', '') === slice.id) {
            slice.classList.add(selectedClass);
            wheel.classList.add('js-color-wheel-focused');
            wheelText.innerHTML += slice.getAttribute('data-color-name');
            wheelDots.forEach(dot => {
              const dotColor = dot.getAttribute('data-dot-color');
              if (dotColor === slice.id) {
                dot.classList.add(visibleClass);
              }
            });
          }
        });
      }
    }
    // update application filters
    if (window.location.href.indexOf('interior') > -1) {
      applicationInteriorRadio.checked = true;
      applicationInteriorRadio.nextElementSibling
        .querySelector('.button--filters-clear')
        .classList.remove('hidden');
      applicationExteriorRadio.nextElementSibling.style.opacity = 0.4;
      applicationExteriorRadio.nextElementSibling
        .querySelector('.button--filters-clear')
        .classList.add('hidden');
    }
    if (window.location.href.indexOf('exterior') > -1) {
      applicationExteriorRadio.checked = true;
      applicationExteriorRadio.nextElementSibling
        .querySelector('.button--filters-clear')
        .classList.remove('hidden');
      applicationInteriorRadio.nextElementSibling.style.opacity = 0.4;
      applicationInteriorRadio.nextElementSibling
        .querySelector('.button--filters-clear')
        .classList.add('hidden');
    }
    // delay labeling filters while swatch rows get adjusted
    setTimeout(() => {
      filterLabelHandler();
    }, 1000);
  }
  /**
   *
   * @param target - active wheel slice
   */
  function matchWheelDotToSliceByColor(target) {
    const targetColorId = target.id;
    wheelDots.forEach(dot => {
      const dotColor = dot.getAttribute('data-dot-color');
      if (targetColorId === dotColor) dot.classList.add(visibleClass);
    });
  }
  function wheelMouseInHandler(e) {
    e.preventDefault();
    const target = e.target;
    matchWheelDotToSliceByColor(target);
  }
  /**
   *
   * @param e - mouseout event
   */
  function wheelMouseOutHandler(e) {
    e.preventDefault();
    wheelSlices.forEach(slice => {
      wheelDots.forEach(dot => {
        const dotColor = dot.getAttribute('data-dot-color');
        // handle if a slice is selected
        if (slice.classList.contains(selectedClass)) {
          if (dotColor === slice.id) {
            return;
          } else {
            dot.classList.remove(visibleClass);
          }
        }
        // else remove dots
        if (!wheel.classList.contains('js-color-wheel-focused')) {
          dot.classList.remove(visibleClass);
        }
      });
    });
  }
  function wheelDotHoverHandler() {
    wheelSlices.forEach(slice => {
      slice.addEventListener('mouseenter', wheelMouseInHandler);
      slice.addEventListener('mouseleave', wheelMouseOutHandler);
    });
  }
  /**
   *
   * @param target - active wheel slice
   */
  function toggleWheelSlice(target) {
    const targetColorName = target.getAttribute('data-color-name');
    if (!target.classList.contains(selectedClass)) {
      wheelSlices.forEach(slice => slice.classList.remove(selectedClass));
      wheelDots.forEach(dot => dot.classList.remove(visibleClass));
      target.classList.add(selectedClass);
      matchWheelDotToSliceByColor(target);
      wheelText.innerHTML = '';
      wheelText.innerHTML += targetColorName ? targetColorName : '';
    } else {
      // reset the wheel when slice is un-toggled
      target.classList.remove(selectedClass);
      wheelText.innerHTML = '';
      wheelDots.forEach(dot => dot.classList.remove(visibleClass));
      wheel.classList.remove('js-color-wheel-focused');
    }
  }
  /**
   *
   * @param e - mouseenter event
   */
  function wheelClickHandler(e) {
    e.preventDefault();
    const target = e.target;
    wheel.classList.add('js-color-wheel-focused');
    toggleWheelSlice(target);
  }
  function handleFilterChanges() {
    const selectedWheelSlice = wheel.querySelector('.color-slice.is-selected');
    const scrollPos = window.pageYOffset || document.documentElement.scrollPos;
    if (applicationInteriorRadio.checked) {
      applyFilterButton.setAttribute('href', '/colors/interior');
      localStorage.setItem('scrollPos', scrollPos);
    }
    if (applicationExteriorRadio.checked) {
      applyFilterButton.setAttribute('href', '/colors/exterior');
      localStorage.setItem('scrollPos', scrollPos);
    }
    if (selectedWheelSlice) {
      for (let color of colors) {
        let dataColorName = selectedWheelSlice
          .getAttribute('data-color-name')
          .toLowerCase();
        if (dataColorName === 'neutrals') dataColorName = 'neutral';
        if (dataColorName === color) {
          applyFilterButton.setAttribute('href', `/colors/${color}`);
          localStorage.setItem('scrollPos', scrollPos);
        }
        if (applicationInteriorRadio.checked && dataColorName === color) {
          applyFilterButton.setAttribute('href', `/colors/interior/${color}`);
          localStorage.setItem('scrollPos', scrollPos);
        }
        if (applicationExteriorRadio.checked && dataColorName === color) {
          applyFilterButton.setAttribute('href', `/colors/exterior/${color}`);
          localStorage.setItem('scrollPos', scrollPos);
        }
      }
    }
  }
  // mobile only
  function openSwatch(target) {
    const expandedSwatch = document.querySelector(
      '.js-open-swatch.is-expanded'
    );
    if (expandedSwatch) expandedSwatch.classList.remove(expandedClass);
    target.classList.add(expandedClass);
  }
  // mobile only
  function closeSwatch(target) {
    target.parentNode.classList.remove(expandedClass);
  }
  function init() {
    heroGradientHandler();
    pageUpdatesHandler();
    wheelDotHoverHandler();
    wheel.addEventListener('click', wheelClickHandler);
    applyFilterButton.addEventListener('click', handleFilterChanges);
    swatch_click();
  }
  function swatch_click() {
    if (isTablet) {
      document.addEventListener('click', function(e) {
        const target = e.target;
        if (target.matches('.js-open-swatch')) {
          openSwatch(target);
        }
        if (target.matches('.js-close-swatch')) {
          closeSwatch(target);
        }
      });
    }
  }
  window.addEventListener('load', () => {
    if (
      localStorage.getItem('scrollPos') !== null &&
      localStorage.getItem('scrollPos').length
    ) {
      document.documentElement.scrollTop = document.body.scrollTop = localStorage.getItem(
        'scrollPos'
      );
      localStorage.removeItem('scrollPos');
    }
  });
  window.addEventListener('DOMContentLoaded', () => {
    if (colorPortfolio) {
      breakpointHandler();
      colorHomepageCheck();
      init();
    }
    if (portfolioDriver) {
      breakpointHandler();
      swatch_click();
    }
  });
})();

export default pcpColorFilter;
